interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function GlobeIcon(props: Props) {
  const { size = 18, className } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17 9C17 13.4183 13.4183 17 9 17M17 9C17 4.58172 13.4183 1 9 1M17 9H1M9 17C4.58172 17 1 13.4183 1 9M9 17C11.001 14.8093 12.138 11.9664 12.1998 9C12.138 6.03363 11.001 3.19068 9 1M9 17C6.99898 14.8093 5.8616 11.9664 5.7998 9C5.8616 6.03363 6.99898 3.19068 9 1M1 9C1 4.58172 4.58172 1 9 1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
